import { render, staticRenderFns } from "./ListPotRefundsOtherAppItem.vue?vue&type=template&id=82365992&"
import script from "./ListPotRefundsOtherAppItem.vue?vue&type=script&lang=js&"
export * from "./ListPotRefundsOtherAppItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports